import { NotificationDispatch } from '@tryhackme/thm-ui-components';

import { QueryErrorResponse } from 'src/common/interfaces';

export const displayErrors = (error: QueryErrorResponse) => {
  if ('errors' in error.data) {
    const errs = Object.keys(error.data.errors ?? {});
    for (let i = 0; i < errs?.length; i++) {
      const errKey = errs[i] as string;
      const errorArray = (error.data.errors as Record<string, string[]>)[errKey];
      if (errorArray?.length && errorArray[0]) {
        NotificationDispatch('error', errorArray[0]);
      }
    }
  } else if ('message' in error.data) {
    NotificationDispatch('error', error.data.message);
  }
};
